module.exports = __webpack_public_path__ + "static/media/recipient-template-diploma.9cd371b0.xlsx";